"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeValidator = void 0;
/**
 * Used to validate fields that should be of certain type.
 */
exports.getTypeValidator = function () {
    return {
        disable: function () { return ({
            name: "type",
            message: "",
        }); },
    };
};
